export default {"src":"/uk/_next/static/media/refer-a-friend.2b482ec8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};